import { useSearch } from 'wouter';

import { SettingsSections } from '../../components/Settings/SettingsDialog';
import { settingsSectionFromSearch } from '../../components/Settings/settingsSections';

export function SettingsPage() {
  const search = useSearch();
  return (
    <section>
      <p className="eyebrow">Account</p>
      <h1>Settings</h1>
      <SettingsSections initialSection={settingsSectionFromSearch(search) || 'keys'} />
    </section>
  );
}
